import { Link } from 'react-router-dom';
import { BRAND, images } from '../data';

export default function Wordmark({ className = '', inverted = false }) {
  return (
    <Link
      className={`wordmark${inverted ? ' is-inverted' : ''} ${className}`.trim()}
      to="/"
      aria-label={`${BRAND} — home`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <img
        className="wordmark-lockup"
        src={inverted ? images.logoOnDark : images.logo}
        alt=""
      />
    </Link>
  );
}
